class SideLabelOverview {
    constructor ($sideLabel, settings) {
        this.$sideLabel = $sideLabel;
        this.$categoryName = this.$sideLabel.querySelector('[data-side-label="category"]');
        this.$filterName = this.$sideLabel.querySelector('[data-side-label="filter"]');
        this.$familyAnchors = document.querySelectorAll('[data-product-family]');
    }

    initialize () {
        if (this.$familyAnchors.length >= 1 &&
            this.$categoryName &&
            this.$filterName
        ) {
            this.handlePositioning();

            window.eventScroller.customFunctions.push(() => {
                this.handlePositioning();
            });
        }
    }

    offset (el) {
        const rect = el.getBoundingClientRect();
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return {
            top: rect.top + scrollTop,
            bottom: rect.top + scrollTop + rect.height,
            left: rect.left + scrollLeft
        };
    }

    updateAnchorList () {
        this.$familyAnchors = document.querySelectorAll('[data-product-family]');
    }

    handlePositioning () {
        const scrollPositionTop = window.eventScroller.getScrollInfo().position;
        const scrollPositionBottom = window.eventScroller.getScrollInfo().position + window.innerHeight;

        for (let i = this.$familyAnchors.length - 1; i >= 0; i--) {
            const $currentAnchor = this.$familyAnchors[i];
            const anchorOffsetTop = this.offset($currentAnchor).top;
            const anchorOffsetBottom = this.offset($currentAnchor).bottom;
            const conditionalStatement = window.innerWidth < 768
                ? (scrollPositionTop <= anchorOffsetBottom && scrollPositionTop >= anchorOffsetTop) // mobile statement: appear when on top of screen, disappear when on bottom of screen
                : (scrollPositionTop <= anchorOffsetBottom && scrollPositionBottom >= anchorOffsetTop); // desktop: appear on bottom of screen, disappear when on bottom of screen

            if (conditionalStatement) {
                this.showSideLabel();

                const category = $currentAnchor.getAttribute('data-product-family');
                this.handleSideLabelCategory(category);
                break;
            } else {
                this.hideSideLabel();
            }
        }
    }

    showSideLabel () {
        this.$sideLabel.classList.add('side-label--visible');
    }

    hideSideLabel () {
        this.$sideLabel.classList.remove('side-label--visible');
    }

    handleSideLabelCategory (category) {
        this.$categoryName.textContent = category;
    }
}

export { SideLabelOverview };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-side-label="overview"]');
        $$roots.forEach($root => {
            window.sideLabelOverview = new SideLabelOverview($root);
            window.sideLabelOverview.initialize();
        });
    }
});
